import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/i18n/translations";
import { logger } from "@/lib/logger";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem("feastar.lang") || "de";
    } catch (err) {
      logger.warn("[lang] localStorage read failed:", err);
      return "de";
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem("feastar.lang", lang);
    } catch (err) {
      logger.warn("[lang] localStorage write failed:", err);
    }
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => {
    const dict = translations[lang] || translations.de;
    return key.split(".").reduce((acc, k) => (acc ? acc[k] : undefined), dict) ?? key;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
}
